/* Youness × Marrakech — vitrine. Reveal on scroll + sticky header + lightbox.
   Aucun appel réseau, aucune capture de données (page 100% statique). */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var root = document.querySelector(".dm-yn");
    if (!root) return;

    /* --- reveal on scroll --- */
    var reveals = document.querySelectorAll(".dm-yn .reveal");
    if ("IntersectionObserver" in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("is-in"); });
    }

    /* --- sticky header background after scroll --- */
    var header = document.querySelector(".dm-yn .yn-header");
    if (header) {
      var onScroll = function () {
        header.classList.toggle("is-stuck", window.scrollY > 40);
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    /* --- lightbox for the UGC gallery --- */
    var tiles = document.querySelectorAll(".dm-yn .yn-gtile[data-full]");
    if (tiles.length) {
      var box = document.createElement("div");
      box.className = "dm-yn-lightbox";
      box.setAttribute("role", "dialog");
      box.setAttribute("aria-modal", "true");
      box.innerHTML =
        '<button class="dm-yn-lightbox__x" aria-label="Fermer">&times;</button><img alt="">';
      document.body.appendChild(box);
      var bImg = box.querySelector("img");

      var close = function () {
        box.classList.remove("is-open");
        bImg.removeAttribute("src");
        document.documentElement.style.overflow = "";
      };
      var open = function (src, alt) {
        bImg.src = src;
        bImg.alt = alt || "";
        box.classList.add("is-open");
        document.documentElement.style.overflow = "hidden";
      };

      tiles.forEach(function (t) {
        t.addEventListener("click", function () {
          open(t.getAttribute("data-full"), t.getAttribute("data-alt"));
        });
      });
      box.addEventListener("click", function (e) {
        if (e.target === box || e.target.classList.contains("dm-yn-lightbox__x")) close();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && box.classList.contains("is-open")) close();
      });
    }
  });
})();
